import React, { useState } from "react";
import PDFIcon from "./images/pdf-icon.png";
import heroSectionPolicy from "./images/hero-section-policy-img.webp";
import Committee_Details from "./pdf/Committee Details of SVCL.pdf";
import "./style.css";

let committeeDetails = [
  {
    name: "Committee Details",
    url: Committee_Details,
  },
];
const CommitteeDetailsContainer = ({ pdfIcon, policyName, policyUrl }) => {
  return (
    <div className="policy-message-box-container">
      <div className="policy-message-box-icon">
        <img
          src={pdfIcon}
          alt="pdf-icon"
          style={{
            height: 30,
            width: 30,
          }}
        />
      </div>
      <p style={{ marginBottom: 10 }}>
        <strong>{policyName}</strong>
      </p>
      <p>
        <a
          className="read-more"
          href={policyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read More
        </a>
      </p>
    </div>
  );
};
const CommitteeDetails = () => {
  const [selectedItem, setSelectedItem] = useState(
    committeeDetails[0]?.name || null
  );
  const [animationTrigger, setAnimationTrigger] = useState(false);
  const [animationDirection, setAnimationDirection] = useState("");
  const [animationKey, setAnimationKey] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  const handleItemClick = (policyName, index) => {
    setSelectedItem(policyName);
    setAnimationTrigger(true);
    setAnimationKey((prevKey) => prevKey + 1);
    if (index > prevIndex) {
      setAnimationDirection("down");
    } else if (index < prevIndex) {
      setAnimationDirection("up");
    } else {
      setAnimationDirection("");
    }

    setPrevIndex(index);
  };

  const renderCommitteeDetailsContainers = (selectedItem) => {
    const committeeDetail = committeeDetails.find(
      (committeeDetail) => committeeDetail.name === selectedItem
    );
    if (!committeeDetail) return null;

    return (
      <div
        key={animationKey}
        className={`policy-attachments ${
          animationTrigger ? `animate-${animationDirection}` : ""
        }`}
      >
        <CommitteeDetailsContainer
          pdfIcon={PDFIcon}
          policyName={committeeDetail.name}
          policyUrl={committeeDetail.url}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="main wrapper">
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionPolicy} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>COMMITTEE DETAILS</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** COMMITTEE DETAILS SECTION STARTS *************** --> */}

        <section className="policy-section">
          <div className="container policy-container">
            {/* <h1 className="main-heading">COMMITTEE DETAILS</h1> */}
            {/* <div className="policy-items-wrapper"> */}
            <div className="policy-side-nav">
              {committeeDetails.map((committeeDetail, index) => {
                return (
                  <>
                    {/* <h4>{committeeDetail.name}</h4> */}
                    <div
                      key={index}
                      className={`policy-side-nav-item ${
                        selectedItem === committeeDetail.name
                          ? "policy-selected"
                          : ""
                      }`}
                      onClick={() =>
                        handleItemClick(committeeDetail.name, index)
                      }
                    >
                      {committeeDetail.name}
                    </div>
                  </>
                );
              })}
            </div>
            {selectedItem && renderCommitteeDetailsContainers(selectedItem)}
            {/* </div> */}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CommitteeDetails;
